import Icon, { IconProps } from './Icon';

import PDFIcon from '../../../assets/icons/pdf.svg?react';

const PDF: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <PDFIcon />
        </Icon>
    );
};

export default PDF;




